function createManagementAxios({ axios, baseURL = "", storage }) {
  const instance = axios.create({
    baseURL,
    withCredentials: true,
  });

  instance.interceptors.request.use((config) => {
    const token = storage.getItem("accesstoken");
    if (token) {
      config.headers.authorization = token;
    }
    return config;
  });

  return instance;
}

module.exports = createManagementAxios;
